export default function Sidebar(list) {
  const desctopSidebarWrapper = document.querySelector(
    ".js-desctop-sidebar-wrapper"
  );
  const mobileSidebarWrapperList = document.querySelectorAll(
    ".js-mobile-sidebar-wrapper"
  );
  const sidebarsElements = list;
  let windowWidth = document.body.clientWidth;
  let desctopStart = true;

  if (windowWidth > 1200) {
    desctopStart = true;
  } else {
    desctopStart = false;
  }

  if (desctopStart) {
    appendDesctopSidebar();
  } else {
    appendMobileSidebar();
  }

  function appendDesctopSidebar() {
    // console.log("width desctop");
    for (let i = 0, len = sidebarsElements.length; i < len; i++) {
      const sidebar = sidebarsElements[i];
      desctopSidebarWrapper.appendChild(sidebar);
    }
  }

  function appendMobileSidebar() {
    // console.log("width mobile");
    for (let i = 0, len = sidebarsElements.length; i < len; i++) {
      const sidebar = sidebarsElements[i];
      mobileSidebarWrapperList[i].appendChild(sidebar);
    }
  }

  window.addEventListener("resize", function resizeWidth() {
    windowWidth = document.body.clientWidth;
    let desctopCurrent = true;

    if (windowWidth > 1200) {
      desctopCurrent = true;
    } else {
      desctopCurrent = false;
    }

    if (desctopCurrent && desctopCurrent !== desctopStart) {
      // console.log("desctopResize", desctopCurrent, desctopStart);
      appendDesctopSidebar();
      desctopStart = desctopCurrent;
    }

    if (!desctopCurrent && desctopCurrent !== desctopStart) {
      // console.log("mobileResize", desctopCurrent, desctopStart);
      appendMobileSidebar();
      desctopStart = desctopCurrent;
    }
  });
}
